import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserData } from './UserDataContext';

const css = `
.git-overlay {
  position: fixed;
  top: 70px;
  right: 20px;
  z-index: 10002;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}

.git-toast {
  pointer-events: auto;
  background: linear-gradient(135deg, #162060, #1a2878);
  border: 3px solid #ffd700;
  border-radius: 8px;
  padding: 16px 20px;
  min-width: 280px;
  max-width: 360px;
  box-shadow: 4px 5px 0px #0a1040, 0 0 20px rgba(255,215,0,0.15);
  animation: gitSlideIn 0.35s ease-out;
  font-family: 'Space Grotesk', sans-serif;
}

.git-icon {
  font-size: 20px;
  margin-right: 8px;
}

.git-title {
  font-family: 'Press Start 2P', cursive;
  font-size: 9px;
  color: #ffd700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 10px;
  text-shadow: 1px 1px 0 #0a1040;
}

.git-name {
  color: #e8eeff;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
}

.git-details {
  color: #8899cc;
  font-size: 13px;
  margin-bottom: 12px;
}

.git-actions {
  display: flex;
  gap: 8px;
}

.git-accept {
  flex: 1;
  padding: 8px 12px;
  border: 2px solid #44dd88;
  border-radius: 4px;
  background: rgba(68,221,136,0.15);
  color: #44dd88;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.15s ease;
}

.git-accept:hover {
  background: #44dd88;
  color: #0d1654;
}

.git-decline {
  padding: 8px 12px;
  border: 2px solid #ff3366;
  border-radius: 4px;
  background: rgba(255,51,102,0.15);
  color: #ff3366;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.15s ease;
}

.git-decline:hover {
  background: #ff3366;
  color: #fff;
}

@keyframes gitSlideIn {
  from { opacity: 0; transform: translateX(60px); }
  to   { opacity: 1; transform: translateX(0); }
}
`;

let styleInjected = false;

const GameInviteToast = () => {
  const { gameInvites, acceptGameInvite, declineGameInvite } = useUserData();
  const navigate = useNavigate();

  if (!styleInjected && typeof document !== 'undefined') {
    const tag = document.createElement('style');
    tag.textContent = css;
    document.head.appendChild(tag);
    styleInjected = true;
  }

  if (!gameInvites || gameInvites.length === 0) return null;

  const handleAccept = async (invite) => {
    try {
      const gameId = await acceptGameInvite(invite);
      navigate(`/game/${gameId}`);
    } catch (e) {
      console.error('Error accepting game invite:', e);
    }
  };

  const handleDecline = async (invite) => {
    try {
      await declineGameInvite(invite);
    } catch (e) {
      console.error('Error declining game invite:', e);
    }
  };

  return (
    <div className="git-overlay">
      {gameInvites.map((invite) => (
        <div key={invite.id} className="git-toast">
          <div className="git-title">
            <span className="git-icon">&#9814;</span>
            Game Challenge
          </div>
          <div className="git-name">{invite.fromUsername}</div>
          <div className="git-details">
            {invite.timeControl} &bull; {invite.side}
          </div>
          <div className="git-actions">
            <button className="git-accept" onClick={() => handleAccept(invite)}>Accept</button>
            <button className="git-decline" onClick={() => handleDecline(invite)}>Decline</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default GameInviteToast;
